import * as React from "react";
import { useTranslation } from "react-i18next";
// START: Codex Edit
import Button from "../../common/Button/Button";
import { useFormDispatch, useFormState } from "../main/ActivationForm/Context/ActivationFormContext";
// END: Codex Edit
import * as _ from "lodash";

type SubscriptionContentProps = {
  title: string
}

const SidebarInfoBlockContent: React.FC<SubscriptionContentProps> = ({title}) => {
  const {t} = useTranslation();
  // START: Codex Edit
  const dispatch = useFormDispatch();
  // END: Codex Edit
  const {
    subscriptionIds,
    orderNumber,
    regionName,
    multicloudOrderReference,
    orderType,
    upstreamEnvironment,
    isAlloy,
    // START: Codex Edit
    orderPillars,
    orderSkus,
    // END: Codex Edit
  } = useFormState();
  // START: Codex Edit
  const hasOrderDetails = Object.keys(orderPillars || {}).length > 0 || (orderSkus || []).length > 0;
  const openOrderDetailsModal = () => {
    dispatch({
      type: "OPEN_ORDER_DETAILS_MODAL",
      payload: "boolean",
      boolean: true,
    });
  };
  // END: Codex Edit

  return (
    <div>
      <h2 className={"title6"}>{title}</h2>
      {_.isString(upstreamEnvironment) &&
          ['ORP_AZURE', 'ODBG_GCP', 'ODBZ_CP', 'ODBZ_AWS'].includes(upstreamEnvironment.toUpperCase()) &&
          _.isString(orderType) &&
          orderType.toUpperCase() === 'PUBLIC' &&
          multicloudOrderReference !== '' ?
          <p key={"order"} className={"subinfo"}>
            <span className={"title8"}>{t('subscriptionBlock.orderRefId', "Order Reference ID") + ": "}</span>{multicloudOrderReference}
          </p> :
          <p key={"order"} className={"subinfo"}>
            <span className={"title8"}>{t('subscriptionBlock.orderNum', "Order Number") + ": "}</span>{orderNumber.split('c')[0]}
          </p>
      }
      {subscriptionIds && subscriptionIds.map((id, index) => (
        <p key={index} className={"subinfo"}>
          <span className={"title8"}>{t('subscriptionBlock.subId', "Subscription ID") + ": "}</span>{id}
        </p>
      ))}
      {/* // START: Codex Edit */}
      {
        !isAlloy
          && regionName
          && regionName!== ''
          && <p>
            <span className="title8">{t('subscriptionBlock.dcrTitle', "Data Center Region")}: </span>{regionName}
          </p>
      }
      {hasOrderDetails && (
        <Button
          type="outline"
          style={{ marginTop: "12px", marginBottom: "8px" }}
          onClick={openOrderDetailsModal}
          text={t('subscriptionBlock.viewDetails', "View Details")}
        />
      )}
      {/* // END: Codex Edit */}
    </div>
  );
};

export default SidebarInfoBlockContent;
